import request from '@/utils/request'

// 获取应用服务列表
export function getAppService(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/appService.getAppService',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取应用变量组
export function getAppVarGroup(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/appService.getAppVarGroup',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 启动应用服务
export function startAppService(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/appService.startAppService',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 停止应用服务
export function stopAppService(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/appService.stopAppService',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 重启多个应用服务
export function restartAppServices(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/appService.restartAppServices',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}